import styled, { css } from "styled-components/native";
import { flexRow, pickStyle as _, pickThemeKey as theme } from "utils";
import { getViewHeight as h, getViewWidth as w } from "utils";
import { ScrollView } from "components";
import { Dimensions } from "react-native";

import {
  ContainerPadding,
  LogoImageStyles,
  NavigationButtonBorderRadius,
  NavigationButtonSize,
  NavigationButtonWrapper,
  NavigationButtonWrapperBG,
  NavigationButtonWrapperPaddingVertical,
  NavigationButtonWrapperPaddingHorizontal,
  SectionTextFont,
  LogoImageMarginTop,
  SectionTextMargin,
  SectionTextMaxWidth,
  ButtonTextVisibility,
  ButtonImageVisibility,
  LogoHeight,
} from "./variables";

export const Container = styled.View`
  height: ${Dimensions.get("window").height}px;
  background-color: ${theme("background")};
`;

export const BgImage = styled.Image`
  height: 100%;
  position: absolute;
  resize-mode: cover;
  width: 100%;
  z-index: 0;
`;

export const SectionWrapper = styled(ScrollView)`
  height: 100%;
`;

export const LogoImage = styled.Image`
  height: ${props =>
    (props.$hideSm && _(LogoHeight)) || theme("height_logo") || 40}px;
  margin: ${_(LogoImageMarginTop) || theme("margin_top_logo") || 83}px auto
    ${_(LogoImageStyles) || theme("margin_bottom_logo") || 84}px;
  resize-mode: contain;
  width: ${theme("width_logo") || 193}px;
`;

export const SectionInfoText = styled.Text`
  color: ${theme("question_text")};
  font-size: ${theme("question_text_size") || _(SectionTextFont) || 24}px;
  margin-bottom: ${_(SectionTextMargin) || 40}px;
  max-width: ${_(SectionTextMaxWidth) || "810px"};
  text-align: center;
  line-height: 28px;
  align-self: center;
  font-family: ${theme("question_text_style") || "Roboto"};
`;

export const ContentWrapper = styled.View`
  padding: ${_(ContainerPadding) || "80px 19px 80px"};
  height: 100%;
`;

export const ButtonWrapper = styled.View`
  flex-direction: ${flexRow()};
  justify-content: space-between;
  background-color: ${props =>
    _(NavigationButtonWrapperBG, props.theme) || "transparent"};
  padding: ${_(NavigationButtonWrapperPaddingVertical) || 0}px
    ${_(NavigationButtonWrapperPaddingHorizontal) || 80}px;
  width: 100%;
  position: absolute;
  bottom: 0;
  margin-bottom: ${_(NavigationButtonWrapper) || 0}px;
  margin-top: 10px;
`;

export const NavigationButton = styled.TouchableOpacity`
  border-radius: ${_(NavigationButtonBorderRadius) || 3}px;
  height: ${_(NavigationButtonSize) || 41}px;
  width: ${_(NavigationButtonSize) || 150}px;
  align-items: center;
  justify-content: center;
`;

export const NextButton = styled(NavigationButton)`
  transition: 500ms all;
  background-color: ${props =>
    props.$isDisabled ? "transparent" : theme("nav_button_background")(props)};}
  border: 2px
    ${props =>
      props.$isDisabled
        ? theme("nav_forward_button_disabled")(props)
        : theme("nav_forward_button")(props)};
`;

export const PrevButton = styled(NavigationButton)`
  ${props =>
    props.$hide
      ? css`
          opacity: 0;
        `
      : css`
          border: 2px ${theme("nav_previous_button")};
          background-color: ${theme("nav_button_background")(props)};
        `}
`;

export const ButtonText = styled.Text`
  font-size: 16px;
  display: ${_(ButtonTextVisibility) || "flex"};
`;

export const ArrowImage = styled.Image`
  height: 15px;
  width: 24px;
  display: ${_(ButtonImageVisibility) || "none"};
  z-index: 2;
  transition: 500ms all;
  tint-color: ${props => {
    if (props.$arrow == "backArrow") {
      if (!props.$hide) {
        return theme("nav_background")(props);
      }
    }
    if (props.$back) {
      return theme("nav_previous_button")(props);
    }
    return props.$isDisabled
      ? theme("nav_forward_button_disabled")(props)
      : theme("nav_previous_button")(props);
  }};
`;

export const NextButtonText = styled(ButtonText)`
  transition: 500ms all;
  color: ${props =>
    props.$isDisabled
      ? theme("nav_forward_button_disabled")(props)
      : theme("nav_forward_button")(props)};
`;

export const PrevButtonText = styled(ButtonText)`
  color: ${theme("nav_previous_button")};
`;

export const QuestionImageContainer = styled.View`
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const QuestionImageItem = styled.Image`
  margin: 10px;
      margin-top: 0px;
  ${props =>
    props.$position === "A" &&
    css`
      margin-bottom: 30px;
    `}
  height: ${props => props.$height}px;
  width: ${props => props.$width}px;
  height: ${props => props.$height}px;
`;
